<template>
  <div class="product-materials-and-cleaning-recommendations">
    <div
      v-if="!!materials?.length"
      class="pmacr-materials-and-warning"
    >
      <div
        v-for="(material, index) of materials"
        :key="`product-material-${material.code}-${index}`"
      >
        <span>
          <strong>{{ $t(`product.material.${material.code}`) }}: </strong>{{ material.text }}
        </span>
      </div>
      <div
        v-if="materialWarning"
        class="pmacr-text"
      >
        <div v-html="$t(`product.warnings.${materialWarning}`)" />
      </div>
    </div>

    <template v-if="!!cleaningRecommendations?.length">
      <div class="pmacr-text">{{ $t('product.careInstructions') }}:</div>
      <ul class="pmacr-cleaning-recommendations">
        <li
          v-for="(recommendation, index) of cleaningRecommendations"
          :key="`cleaning-recommendation-${recommendation}-${index}`"
        >
          {{ recommendation }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    materials: {
      type: Array,
      default: () => [],
    },
    cleaningRecommendations: {
      type: Array,
      default: () => [],
    },
    materialWarning: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.product-materials-and-cleaning-recommendations {
  .pmacr-materials-and-warning {
    margin-bottom: $pad;
  }

  .pmacr-text {
    font-weight: map-get($font-weights, bold);
    font-size: map-get($font-sizes, l);

    :deep(p) {
      font-size: map-get($font-sizes, l);
    }
  }

  .pmacr-cleaning-recommendations {
    padding-left: 1.25 * $pad;
    margin-top: 0.3125 * $pad;
    li {
      padding: 0.125 * $pad 0;
    }
  }
}
</style>
